export const fromPx = (size: string): number =>
  Number(size.replaceAll('px', ''));

export const getCssVariable = (variable: string): string =>
  window.getComputedStyle(document.body).getPropertyValue(variable);
